import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/results", label: "Results" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const PublicNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="zq-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo">
          <Logo light />
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition ${
                  isActive ? "text-orange-400" : "text-gray-300 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/login" className="zq-btn zq-btn-primary ml-3" data-testid="nav-login-btn">
            Login
          </Link>
          <Link to="/pricing" className="zq-btn zq-btn-outline" style={{ background: "white" }} data-testid="nav-cta">
            Get Started
          </Link>
        </nav>
        <button className="md:hidden text-white" onClick={() => setOpen((v) => !v)} data-testid="nav-mobile-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#1c1c1c]">
          <div className="px-5 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium ${
                    isActive ? "text-orange-400" : "text-gray-300"
                  }`
                }
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/login" className="zq-btn zq-btn-primary mt-2" onClick={() => setOpen(false)} data-testid="nav-mobile-login">
              Login
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export const PublicFooter = () => {
  return (
    <footer className="bg-[#1c1c1c] text-gray-400 mt-12">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <Logo light />
          <p className="text-sm mt-4 text-gray-400">Desi flavour. Digital future.</p>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-3">Product</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features" className="hover:text-orange-400">Features</Link></li>
            <li><Link to="/pricing" className="hover:text-orange-400">Pricing</Link></li>
            <li><Link to="/results" className="hover:text-orange-400">Results</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-orange-400">About</Link></li>
            <li><Link to="/blog" className="hover:text-orange-400">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-orange-400">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-3">Get in touch</h4>
          <p className="text-sm">zaykaqr@gmail.com</p>
          <p className="text-sm mt-1">ZaykaQR.space</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} ZaykaQR · All rights reserved
      </div>
    </footer>
  );
};

export const PublicShell = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-zq-cream">
    <PublicNav />
    <main className="flex-1">{children}</main>
    <PublicFooter />
  </div>
);
